import React from 'react';
import {Alert, Modal, Spin} from 'antd';
import {ResearchReportBody} from '../../tools/research-report/components/ResearchReportBody';
import {formatReportTime, useResearchReportDetail} from './useResearchReportDetail';

interface Props {
    open: boolean;
    /** 执行记录关联的研报 ID；为空时弹窗展示空态 */
    reportId: number | null;
    onClose: () => void;
}

/**
 * 执行记录 → 研报弹窗：复用研报页正文组件，保证与 /tools/research-report 完全同源
 */
export const HedgeReportModal: React.FC<Props> = ({open, reportId, onClose}) => {
    const {detail, loading, error} = useResearchReportDetail(open, reportId);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={1100}
            destroyOnClose
            title={detail ? `${detail.symbol} 研报 · ${formatReportTime(detail.generatedAt)}` : '研报详情'}
        >
            <div className="hedge-report-modal-body">
                {loading ? <div className="hedge-report-mask"><Spin/></div> : null}
                {!loading && error ? <Alert type="warning" showIcon message={error}/> : null}
                {!loading && !error && detail ? (
                    <div className="hedge-report-embed">
                        <ResearchReportBody detail={detail}/>
                    </div>
                ) : null}
            </div>
        </Modal>
    );
};

export default HedgeReportModal;
